import { render, staticRenderFns } from "./EditIcon.vue?vue&type=template&id=d99b0d16"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d99b0d16')) {
      api.createRecord('d99b0d16', component.options)
    } else {
      api.reload('d99b0d16', component.options)
    }
    module.hot.accept("./EditIcon.vue?vue&type=template&id=d99b0d16", function () {
      api.rerender('d99b0d16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/libs/lightbox/EditIcon.vue"
export default component.exports